import * as DialogPrimitive from '@radix-ui/react-dialog'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export interface LoadingOverlayProps {
  open: boolean
  title?: string
  description?: string
  className?: string
}

export function LoadingOverlay({
  open,
  title,
  description,
  className,
}: LoadingOverlayProps) {
  const { t } = useTranslation('shared')

  return (
    <DialogPrimitive.Root open={open}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className='fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 backdrop-blur-[2px]'>
          <DialogPrimitive.Content
            className={cn(
              'w-full max-w-[600px] rounded-2xl border border-[#e7e9ef] bg-white px-8 py-10 shadow-[0px_1px_2px_rgba(38,45,66,0.05),0px_8px_8px_rgba(38,45,66,0.1)] outline-none sm:px-12 sm:py-12',
              className
            )}
            onEscapeKeyDown={event => event.preventDefault()}
            onPointerDownOutside={event => event.preventDefault()}
            onInteractOutside={event => event.preventDefault()}
          >
            <div className='flex flex-col items-center gap-6 text-center'>
              <div
                aria-hidden='true'
                className='relative size-16 shrink-0 animate-spin rounded-full bg-[conic-gradient(from_90deg,rgba(255,90,31,0)_0deg,#ff5a1f_360deg)] after:absolute after:inset-[7px] after:rounded-full after:bg-white'
              />
              <div className='flex w-full flex-col items-center gap-3'>
                <DialogPrimitive.Title className='w-full text-2xl font-semibold leading-[1.2] tracking-[-0.48px] text-[#171a20]'>
                  {title ?? t('loadingOverlay.title')}
                </DialogPrimitive.Title>
                <DialogPrimitive.Description className='max-w-[420px] text-base leading-[1.4] text-[#3d434e]'>
                  {description ?? t('loadingOverlay.description')}
                </DialogPrimitive.Description>
              </div>
            </div>
          </DialogPrimitive.Content>
        </DialogPrimitive.Overlay>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}

export default LoadingOverlay
